import styled from "styled-components";

const PageHeading = styled.h1`
    font-size: 26px;
    font-weight: bold;
    line-height: 1.2;
    margin: 0;
`;

export default PageHeading;
